import * as React from 'react';
import { fm } from 'Components/FormatMessage';
import { isPartialDate } from 'neuro-utils';
import { getLatestDiscontinuation, getLatestGenerator } from '../utils';
import { generatorsWithTwoConnectors } from '../Document/config';
import TileContentMaker from 'Components/DashboardTile/TileContentMaker';
import { formatPartialDate } from 'Utility/date';
import { sortDocumentsDescending } from 'Utility/documentHandling';

const VnsDash = ({ documents }: IOwnProps): React.ReactNode => {
  const docs = documents.toSorted(sortDocumentsDescending);
  const doc = docs.at(0);
  const generator = doc && getLatestGenerator(doc) ? (getLatestGenerator(doc)?.generator ?? '-') : '-';

  return doc ? (
    <TileContentMaker
      type="bigHeaderInfo"
      bigHeaderText={
        <div style={{ display: 'grid' }}>
          <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {generator}
            {generatorsWithTwoConnectors.includes(generator) && <span> {fm('vns.generatorTwoConnectors')}</span>}
          </div>
        </div>
      }
      bigHeaderTextSubheader={fm('vns.generator')}
      data={[
        {
          title: fm('vns.started'),
          value: isPartialDate(doc.date) ? formatPartialDate(doc.date) : null,
          key: 'startDate',
        },
        {
          title: fm('vns.status'),
          value: doc.status ? fm('vns.opts.status.' + doc.status) : undefined,
          key: 'status',
        },
        ...(doc.status === 'inProgress'
          ? [
              ...(getLatestGenerator(doc)
                ? [
                    {
                      title: fm('vns.generatorChanged'),
                      value: isPartialDate(getLatestGenerator(doc)?.date)
                        ? formatPartialDate(getLatestGenerator(doc)?.date)
                        : null,
                      key: 'generatorChanged',
                    },
                  ]
                : []),
              ...(getLatestGenerator(doc) && getLatestGenerator(doc)?.generatorNextChangeDate
                ? [
                    {
                      title: fm('vns.generatorNextChangeDate'),
                      value: isPartialDate(getLatestGenerator(doc)?.generatorNextChangeDate)
                        ? formatPartialDate(getLatestGenerator(doc)?.generatorNextChangeDate)
                        : null,
                      key: 'generatorNextChangeDate',
                    },
                  ]
                : []),
            ]
          : doc.status === 'suspended'
            ? [
                ...(Array.isArray(doc.discontinuations) && getLatestDiscontinuation(doc.discontinuations)
                  ? [
                      {
                        title: fm('vns.discontinuationDate'),
                        value: isPartialDate(getLatestDiscontinuation(doc.discontinuations)?.date)
                          ? formatPartialDate(getLatestDiscontinuation(doc.discontinuations)?.date)
                          : null,
                        key: 'discontinuationDate',
                      },
                    ]
                  : []),
                ...(Array.isArray(doc.discontinuations) &&
                getLatestDiscontinuation(doc.discontinuations) &&
                getLatestDiscontinuation(doc.discontinuations)?.reason
                  ? [
                      {
                        title: fm('vns.discontinuationReason'),
                        value: fm(
                          `vns.opts.discontinuationReason.${getLatestDiscontinuation(doc.discontinuations)?.reason}`,
                        ),
                        key: 'discontinuationReasonShort',
                      },
                    ]
                  : []),
              ]
            : doc.status === 'ended'
              ? [
                  ...(doc.endReason
                    ? [
                        {
                          title: fm('vns.endReason'),
                          value: fm(`vns.opts.endReason.${doc.endReason}`),
                          key: 'endReason',
                        },
                      ]
                    : []),
                  ...(doc.removed === 'yes'
                    ? [
                        {
                          title: fm('vns.removalDate'),
                          value: isPartialDate(doc.removalDate) ? formatPartialDate(doc.removalDate) : null,
                          key: 'removalDate',
                        },
                        {
                          title: fm('vns.removalType'),
                          value: doc.removalType ? fm(`vns.opts.removalType.${doc.removalType}`) : null,
                          key: 'removalType',
                        },
                      ]
                    : []),
                ]
              : []),
      ]}
    />
  ) : null;
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'vns'>[];
}

export default VnsDash;
